import Vue from 'vue';
import Map from 'ol/Map';
import {
	transform
} from "ol/proj";
import {
	syncGetLocalJson
} from "@/http/axios";

let echarts = require('echarts/lib/echarts');
import ol3Echarts from 'ol-echarts/dist/ol-echarts';

import Overlay from "ol/Overlay";
import {
	postTideWay,
	getAsiaLinePower
} from "../http/axios";
// import { set } from 'core-js/core/dict';
// import EChartsLayer from 'ol-echarts'




var heatLineLayer;
var heatLineAnimatonLayer = null;
var timeDataSet;
var hStep = 2;
var pointerPath = 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z';
var heatLineLayerList = [];
var tideWayTimeOut = [];
var tabelIndex = 0;
var tideWayCount = 0;
var asiaHeatlineData = null;
let asiaChildLinePowerData=[]

var tideWaySingleFeatures = [];

const pathSymbols = {
	reindeer: 'path://M-22.788,24.521c2.08-0.986,3.611-3.905,4.984-5.892 c-2.686,2.782-5.047,5.884-9.102,7.312c-0.992,0.005-0.25-2.016,0.34-2.362l1.852-0.41c0.564-0.218,0.785-0.842,0.902-1.347 c2.133-0.727,4.91-4.129,6.031-6.194c1.748-0.7,4.443-0.679,5.734-2.293c1.176-1.468,0.393-3.992,1.215-6.557 c0.24-0.754,0.574-1.581,1.008-2.293c-0.611,0.011-1.348-0.061-1.959-0.608c-1.391-1.245-0.785-2.086-1.297-3.313 c1.684,0.744,2.5,2.584,4.426,2.586C-8.46,3.012-8.255,2.901-8.04,2.824c6.031-1.952,15.182-0.165,19.498-3.937 c1.15-3.933-1.24-9.846-1.229-9.938c0.008-0.062-1.314-0.004-1.803-0.258c-1.119-0.771-6.531-3.75-0.17-3.33 c0.314-0.045,0.943,0.259,1.439,0.435c-0.289-1.694-0.92-0.144-3.311-1.946c0,0-1.1-0.855-1.764-1.98 c-0.836-1.09-2.01-2.825-2.992-4.031c-1.523-2.476,1.367,0.709,1.816,1.108c1.768,1.704,1.844,3.281,3.232,3.983 c0.195,0.203,1.453,0.164,0.926-0.468c-0.525-0.632-1.367-1.278-1.775-2.341c-0.293-0.703-1.311-2.326-1.566-2.711 c-0.256-0.384-0.959-1.718-1.67-2.351c-1.047-1.187-0.268-0.902,0.521-0.07c0.789,0.834,1.537,1.821,1.672,2.023 c0.135,0.203,1.584,2.521,1.725,2.387c0.102-0.259-0.035-0.428-0.158-0.852c-0.125-0.423-0.912-2.032-0.961-2.083 c-0.357-0.852-0.566-1.908-0.598-3.333c0.4-2.375,0.648-2.486,0.549-0.705c0.014,1.143,0.031,2.215,0.602,3.247 c0.807,1.496,1.764,4.064,1.836,4.474c0.561,3.176,2.904,1.749,2.281-0.126c-0.068-0.446-0.109-2.014-0.287-2.862 c-0.18-0.849-0.219-1.688-0.113-3.056c0.066-1.389,0.232-2.055,0.277-2.299c0.285-1.023,0.4-1.088,0.408,0.135 c-0.059,0.399-0.131,1.687-0.125,2.655c0.064,0.642-0.043,1.768,0.172,2.486c0.654,1.928-0.027,3.496,1,3.514 c1.805-0.424,2.428-1.218,2.428-2.346c-0.086-0.704-0.121-0.843-0.031-1.193c0.221-0.568,0.359-0.67,0.312-0.076 c-0.055,0.287,0.031,0.533,0.082,0.794c0.264,1.197,0.912,0.114,1.283-0.782c0.15-0.238,0.539-2.154,0.545-2.522 c-0.023-0.617,0.285-0.645,0.309,0.01c0.064,0.422-0.248,2.646-0.205,2.334c-0.338,1.24-1.105,3.402-3.379,4.712 c-0.389,0.12-1.186,1.286-3.328,2.178c0,0,1.729,0.321,3.156,0.246c1.102-0.19,3.707-0.027,4.654,0.269 c1.752,0.494,1.531-0.053,4.084,0.164c2.26-0.4,2.154,2.391-1.496,3.68c-2.549,1.405-3.107,1.475-2.293,2.984 c3.484,7.906,2.865,13.183,2.193,16.466c2.41,0.271,5.732-0.62,7.301,0.725c0.506,0.333,0.648,1.866-0.457,2.86 c-4.105,2.745-9.283,7.022-13.904,7.662c-0.977-0.194,0.156-2.025,0.803-2.247l1.898-0.03c0.596-0.101,0.936-0.669,1.152-1.139 c3.16-0.404,5.045-3.775,8.246-4.818c-4.035-0.718-9.588,3.981-12.162,1.051c-5.043,1.423-11.449,1.84-15.895,1.111 c-3.105,2.687-7.934,4.021-12.115,5.866c-3.271,3.511-5.188,8.086-9.967,10.414c-0.986,0.119-0.48-1.974,0.066-2.385l1.795-0.618 C-22.995,25.682-22.849,25.035-22.788,24.521z',
	plane: 'path://M1.112,32.559l2.998,1.205l-2.882,2.268l-2.215-0.012L1.112,32.559z M37.803,23.96 c0.158-0.838,0.5-1.509,0.961-1.904c-0.096-0.037-0.205-0.071-0.344-0.071c-0.777-0.005-2.068-0.009-3.047-0.009 c-0.633,0-1.217,0.066-1.754,0.18l2.199,1.804H37.803z M39.738,23.036c-0.111,0-0.377,0.325-0.537,0.924h1.076 C40.115,23.361,39.854,23.036,39.738,23.036z M39.934,39.867c-0.166,0-0.674,0.705-0.674,1.986s0.506,1.986,0.674,1.986 s0.672-0.705,0.672-1.986S40.102,39.867,39.934,39.867z M38.963,38.889c-0.098-0.038-0.209-0.07-0.348-0.073 c-0.082,0-0.174,0-0.268-0.001l-7.127,4.671c0.879,0.821,2.42,1.417,4.348,1.417c0.979,0,2.27-0.006,3.047-0.01 c0.139,0,0.25-0.034,0.348-0.072c-0.646-0.555-1.07-1.643-1.07-2.967C37.891,40.529,38.316,39.441,38.963,38.889z M32.713,23.96 l-12.37-10.116l-4.693-0.004c0,0,4,8.222,4.827,10.121H32.713z M59.311,32.374c-0.248,2.104-5.305,3.172-8.018,3.172H39.629 l-25.325,16.61L9.607,52.16c0,0,6.687-8.479,7.95-10.207c1.17-1.6,3.019-3.699,3.027-6.407h-2.138 c-5.839,0-13.816-3.789-18.472-5.583c-2.818-1.085-2.396-4.04-0.031-4.04h0.039l-3.299-11.371h3.617c0,0,4.352,5.696,5.846,7.5 c2,2.416,4.503,3.678,8.228,3.87h30.727c2.17,0,4.311,0.417,6.252,1.046c3.49,1.175,5.863,2.7,7.199,4.027 C59.145,31.584,59.352,32.025,59.311,32.374z M22.069,30.408c0-0.815-0.661-1.475-1.469-1.475c-0.812,0-1.471,0.66-1.471,1.475 s0.658,1.475,1.471,1.475C21.408,31.883,22.069,31.224,22.069,30.408z M27.06,30.408c0-0.815-0.656-1.478-1.466-1.478 c-0.812,0-1.471,0.662-1.471,1.478s0.658,1.477,1.471,1.477C26.404,31.885,27.06,31.224,27.06,30.408z M32.055,30.408 c0-0.815-0.66-1.475-1.469-1.475c-0.808,0-1.466,0.66-1.466,1.475s0.658,1.475,1.466,1.475 C31.398,31.883,32.055,31.224,32.055,30.408z M37.049,30.408c0-0.815-0.658-1.478-1.467-1.478c-0.812,0-1.469,0.662-1.469,1.478 s0.656,1.477,1.469,1.477C36.389,31.885,37.049,31.224,37.049,30.408z M42.039,30.408c0-0.815-0.656-1.478-1.465-1.478 c-0.811,0-1.469,0.662-1.469,1.478s0.658,1.477,1.469,1.477C41.383,31.885,42.039,31.224,42.039,30.408z M55.479,30.565 c-0.701-0.436-1.568-0.896-2.627-1.347c-0.613,0.289-1.551,0.476-2.73,0.476c-1.527,0-1.639,2.263,0.164,2.316 C52.389,32.074,54.627,31.373,55.479,30.565z',
	rocket: 'path://M-244.396,44.399c0,0,0.47-2.931-2.427-6.512c2.819-8.221,3.21-15.709,3.21-15.709s5.795,1.383,5.795,7.325C-237.818,39.679-244.396,44.399-244.396,44.399z M-260.371,40.827c0,0-3.881-12.946-3.881-18.319c0-2.416,0.262-4.566,0.669-6.517h17.684c0.411,1.952,0.675,4.104,0.675,6.519c0,5.291-3.87,18.317-3.87,18.317H-260.371z M-254.745,18.951c-1.99,0-3.603,1.676-3.603,3.744c0,2.068,1.612,3.744,3.603,3.744c1.988,0,3.602-1.676,3.602-3.744S-252.757,18.951-254.745,18.951z M-255.521,2.228v-5.098h1.402v4.969c1.603,1.213,5.941,5.069,7.901,12.5h-17.05C-261.373,7.373-257.245,3.558-255.521,2.228zM-265.07,44.399c0,0-6.577-4.721-6.577-14.896c0-5.942,5.794-7.325,5.794-7.325s0.393,7.488,3.211,15.708C-265.539,41.469-265.07,44.399-265.07,44.399z M-252.36,45.15l-1.176-1.22L-254.789,48l-1.487-4.069l-1.019,2.116l-1.488-3.826h8.067L-252.36,45.15z',
	train: 'path://M67.335,33.596L67.335,33.596c-0.002-1.39-1.153-3.183-3.328-4.218h-9.096v-2.07h5.371 c-4.939-2.07-11.199-4.141-14.89-4.141H19.72v12.421v5.176h38.373c4.033,0,8.457-1.035,9.142-5.176h-0.027 c0.076-0.367,0.129-0.751,0.129-1.165L67.335,33.596L67.335,33.596z M27.999,30.413h-3.105v-4.141h3.105V30.413z M35.245,30.413 h-3.104v-4.141h3.104V30.413z M42.491,30.413h-3.104v-4.141h3.104V30.413z M49.736,30.413h-3.104v-4.141h3.104V30.413z  M14.544,40.764c1.143,0,2.07-0.927,2.07-2.07V35.59V25.237c0-1.145-0.928-2.07-2.07-2.07H-9.265c-1.143,0-2.068,0.926-2.068,2.07 v10.351v3.105c0,1.144,0.926,2.07,2.068,2.07H14.544L14.544,40.764z M8.333,26.272h3.105v4.141H8.333V26.272z M1.087,26.272h3.105 v4.141H1.087V26.272z M-6.159,26.272h3.105v4.141h-3.105V26.272z M-9.265,41.798h69.352v1.035H-9.265V41.798z',
	ship: 'path://M16.678,17.086h9.854l-2.703,5.912c5.596,2.428,11.155,5.575,16.711,8.607c3.387,1.847,6.967,3.75,10.541,5.375 v-6.16l-4.197-2.763v-5.318L33.064,12.197h-11.48L20.43,15.24h-4.533l-1.266,3.286l0.781,0.345L16.678,17.086z M49.6,31.84 l0.047,1.273L27.438,20.998l0.799-1.734L49.6,31.84z M33.031,15.1l12.889,8.82l0.027,0.769L32.551,16.1L33.031,15.1z M22.377,14.045 h9.846l-1.539,3.365l-2.287-1.498h1.371l0.721-1.352h-2.023l-0.553,1.037l-0.541-0.357h-0.34l0.359-0.684h-2.025l-0.361,0.684 h-3.473L22.377,14.045z M23.695,20.678l-0.004,0.004h0.004V20.678z M24.828,18.199h-2.031l-0.719,1.358h2.029L24.828,18.199z  M40.385,34.227c-12.85-7.009-25.729-14.667-38.971-12.527c1.26,8.809,9.08,16.201,8.213,24.328 c-0.553,4.062-3.111,0.828-3.303,7.137c15.799,0,32.379,0,48.166,0l0.066-4.195l1.477-7.23 C50.842,39.812,45.393,36.961,40.385,34.227z M13.99,35.954c-1.213,0-2.195-1.353-2.195-3.035c0-1.665,0.98-3.017,2.195-3.017 c1.219,0,2.195,1.352,2.195,3.017C16.186,34.604,15.213,35.954,13.99,35.954z M23.691,20.682h-2.02l-0.588,1.351h2.023 L23.691,20.682z M19.697,18.199l-0.721,1.358h2.025l0.727-1.358H19.697z',
	car: 'path://M49.592,40.883c-0.053,0.354-0.139,0.697-0.268,0.963c-0.232,0.475-0.455,0.519-1.334,0.475 c-1.135-0.053-2.764,0-4.484,0.068c0,0.476,0.018,0.697,0.018,0.697c0.111,1.299,0.697,1.342,0.931,1.342h3.7 c0.326,0,0.628,0,0.861-0.154c0.301-0.196,0.43-0.772,0.543-1.78c0.017-0.146,0.025-0.336,0.033-0.56v-0.01 c0-0.068,0.008-0.154,0.008-0.25V41.58l0,0C49.6,41.348,49.6,41.09,49.592,40.883L49.592,40.883z M6.057,40.883 c0.053,0.354,0.137,0.697,0.268,0.963c0.23,0.475,0.455,0.519,1.334,0.475c1.137-0.053,2.762,0,4.484,0.068 c0,0.476-0.018,0.697-0.018,0.697c-0.111,1.299-0.697,1.342-0.93,1.342h-3.7c-0.328,0-0.602,0-0.861-0.154 c-0.309-0.18-0.43-0.772-0.541-1.78c-0.018-0.146-0.027-0.336-0.035-0.56v-0.01c0-0.068-0.008-0.154-0.008-0.25V41.58l0,0 C6.057,41.348,6.057,41.09,6.057,40.883L6.057,40.883z M49.867,32.766c0-2.642-0.344-5.224-0.482-5.507 c-0.104-0.207-0.766-0.749-2.271-1.773c-1.522-1.042-1.487-0.887-1.766-1.566c0.25-0.078,0.492-0.224,0.639-0.241 c0.326-0.034,0.345,0.274,1.023,0.274c0.68,0,2.152-0.18,2.453-0.48c0.301-0.303,0.396-0.405,0.396-0.672 c0-0.268-0.156-0.818-0.447-1.146c-0.293-0.327-1.541-0.49-2.273-0.585c-0.729-0.095-0.834,0-1.022,0.121 c-0.304,0.189-0.32,1.919-0.32,1.919l-0.713,0.018c-0.465-1.146-1.11-3.452-2.117-5.269c-1.103-1.979-2.256-2.599-2.737-2.754 c-0.474-0.146-0.904-0.249-4.131-0.576c-3.298-0.344-5.922-0.388-8.262-0.388c-2.342,0-4.967,0.052-8.264,0.388 c-3.229,0.336-3.66,0.43-4.133,0.576s-1.633,0.775-2.736,2.754c-1.006,1.816-1.652,4.123-2.117,5.269L9.87,23.109 c0,0-0.008-1.729-0.318-1.919c-0.189-0.121-0.293-0.225-1.023-0.121c-0.732,0.104-1.98,0.258-2.273,0.585 c-0.293,0.327-0.447,0.878-0.447,1.146c0,0.267,0.094,0.379,0.396,0.672c0.301,0.301,1.773,0.48,2.453,0.48 c0.68,0,0.697-0.309,1.023-0.274c0.146,0.018,0.396,0.163,0.637,0.241c-0.283,0.68-0.24,0.524-1.764,1.566 c-1.506,1.033-2.178,1.566-2.271,1.773c-0.139,0.283-0.482,2.865-0.482,5.508s0.189,5.02,0.189,5.86c0,0.354,0,0.976,0.076,1.565 c0.053,0.354,0.129,0.697,0.268,0.966c0.232,0.473,0.447,0.516,1.334,0.473c1.137-0.051,2.779,0,4.477,0.07 c1.135,0.043,2.297,0.086,3.33,0.11c2.582,0.051,1.826-0.379,2.928-0.36c1.102,0.016,5.447,0.196,9.424,0.196 c3.976,0,8.332-0.182,9.423-0.196c1.102-0.019,0.346,0.411,2.926,0.36c1.033-0.018,2.195-0.067,3.332-0.11 c1.695-0.062,3.348-0.121,4.477-0.07c0.886,0.043,1.103,0,1.332-0.473c0.132-0.269,0.218-0.611,0.269-0.966 c0.086-0.592,0.078-1.213,0.078-1.565C49.678,37.793,49.867,35.408,49.867,32.766L49.867,32.766z M13.219,19.735 c0.412-0.964,1.652-2.9,2.256-3.244c0.145-0.087,1.426-0.491,4.637-0.706c2.953-0.198,6.217-0.276,7.73-0.276 c1.513,0,4.777,0.078,7.729,0.276c3.201,0.215,4.502,0.611,4.639,0.706c0.775,0.533,1.842,2.28,2.256,3.244 c0.412,0.965,0.965,2.858,0.861,3.116c-0.104,0.258,0.104,0.388-1.291,0.275c-1.387-0.103-10.088-0.216-14.185-0.216 c-4.088,0-12.789,0.113-14.184,0.216c-1.395,0.104-1.188-0.018-1.291-0.275C12.254,22.593,12.805,20.708,13.219,19.735 L13.219,19.735z M16.385,30.511c-0.619,0.155-0.988,0.491-1.764,0.482c-0.775,0-2.867-0.353-3.314-0.371 c-0.447-0.017-0.842,0.302-1.076,0.362c-0.23,0.06-0.688-0.104-1.377-0.318c-0.688-0.216-1.092-0.155-1.316-1.094 c-0.232-0.93,0-2.264,0-2.264c1.488-0.068,2.928,0.069,5.621,0.826c2.693,0.758,4.191,2.213,4.191,2.213 S17.004,30.357,16.385,30.511L16.385,30.511z M36.629,37.293c-1.23,0.164-6.386,0.207-8.794,0.207c-2.412,0-7.566-0.051-8.799-0.207 c-1.256-0.164-2.891-1.67-1.764-2.865c1.523-1.627,1.24-1.576,4.701-2.023C24.967,32.018,27.239,32,27.834,32 c0.584,0,2.865,0.025,5.859,0.404c3.461,0.447,3.178,0.396,4.699,2.022C39.521,35.623,37.887,37.129,36.629,37.293L36.629,37.293z  M48.129,29.582c-0.232,0.93-0.629,0.878-1.318,1.093c-0.688,0.216-1.145,0.371-1.377,0.319c-0.231-0.053-0.627-0.371-1.074-0.361 c-0.448,0.018-2.539,0.37-3.313,0.37c-0.772,0-1.146-0.328-1.764-0.481c-0.621-0.154-0.966-0.154-0.966-0.154 s1.49-1.464,4.191-2.213c2.693-0.758,4.131-0.895,5.621-0.826C48.129,27.309,48.361,28.643,48.129,29.582L48.129,29.582z',
	run: 'path://M13.676,32.955c0.919-0.031,1.843-0.008,2.767-0.008v0.007c0.827,0,1.659,0.041,2.486-0.019 c0.417-0.028,1.118,0.325,1.14-0.545c0.014-0.637-0.156-1.279-0.873-1.367c-1.919-0.241-3.858-0.233-5.774,0.019 c-0.465,0.062-0.998,0.442-0.832,1.069C12.715,32.602,13.045,32.977,13.676,32.955z M14.108,29.013 c1.47-0.007,2.96-0.122,4.414,0.035c1.792,0.192,3.1-0.412,4.273-2.105c-3.044,0-5.882,0.014-8.719-0.01 c-0.768-0.005-1.495,0.118-1.461,1C12.642,28.731,13.329,29.014,14.108,29.013z M23.678,36.593c-0.666-0.69-1.258-1.497-2.483-1.448 c-2.341,0.095-4.689,0.051-7.035,0.012c-0.834-0.014-1.599,0.177-1.569,1.066c0.031,0.854,0.812,1.062,1.636,1.043 c1.425-0.033,2.852-0.01,4.278-0.01v-0.01c1.562,0,3.126,0.008,4.691-0.005C23.614,37.239,24.233,37.174,23.678,36.593z  M32.234,42.292h-0.002c-1.075,0.793-2.589,0.345-3.821,1.048c-0.359,0.193-0.663,0.465-0.899,0.799 c-1.068,1.623-2.052,3.301-3.117,4.928c-0.625,0.961-0.386,1.805,0.409,2.395c0.844,0.628,1.874,0.617,2.548-0.299 c1.912-2.573,3.761-5.197,5.621-7.814C33.484,42.619,33.032,42.387,32.234,42.292z M43.527,28.401 c-0.688-1.575-2.012-0.831-3.121-0.895c-1.047-0.058-2.119,1.128-3.002,0.345c-0.768-0.677-1.213-1.804-1.562-2.813 c-0.45-1.305-1.495-2.225-2.329-3.583c2.953,1.139,4.729,0.077,5.592-1.322c0.99-1.61,0.718-3.725-0.627-4.967 c-1.362-1.255-3.414-1.445-4.927-0.452c-1.933,1.268-2.206,2.893-0.899,6.11c-2.098-0.659-3.835-1.654-5.682-2.383 c-0.735-0.291-1.437-1.017-2.293-0.666c-2.263,0.927-4.522,1.885-6.723,2.95c-1.357,0.658-1.649,1.593-1.076,2.638 c0.462,0.851,1.643,1.126,2.806,0.617c0.993-0.433,1.994-0.857,2.951-1.374c1.599-0.86,3.044-0.873,4.604,0.214 c1.017,0.707,0.873,1.137,0.123,1.849c-1.701,1.615-3.516,3.12-4.933,5.006c-1.042,1.388-0.993,2.817,0.255,4.011 c1.538,1.471,3.148,2.869,4.708,4.315c0.485,0.444,0.907,0.896-0.227,1.104c-1.523,0.285-3.021,0.694-4.538,1.006 c-1.109,0.225-2.02,1.259-1.83,2.16c0.223,1.07,1.548,1.756,2.687,1.487c3.003-0.712,6.008-1.413,9.032-2.044 c1.549-0.324,2.273-1.869,1.344-3.115c-0.868-1.156-1.801-2.267-2.639-3.445c-1.964-2.762-1.95-2.771,0.528-5.189 c1.394-1.357,1.379-1.351,2.437,0.417c0.461,0.769,0.854,1.703,1.99,1.613c2.238-0.181,4.407-0.755,6.564-1.331 C43.557,30.447,43.88,29.206,43.527,28.401z',
	walk: 'path://M29.902,23.275c1.86,0,3.368-1.506,3.368-3.365c0-1.859-1.508-3.365-3.368-3.365 c-1.857,0-3.365,1.506-3.365,3.365C26.537,21.769,28.045,23.275,29.902,23.275z M36.867,30.74c-1.666-0.467-3.799-1.6-4.732-4.199 c-0.932-2.6-3.131-2.998-4.797-2.998s-7.098,3.894-7.098,3.894c-1.133,1.001-2.1,6.502-0.967,6.769 c1.133,0.269,1.266-1.533,1.934-3.599c0.666-2.065,3.797-3.466,3.797-3.466s0.201,2.467-0.398,3.866 c-0.599,1.399-1.133,2.866-1.467,6.198s-1.6,3.665-3.799,6.266c-2.199,2.598-0.6,3.797,0.398,3.664 c1.002-0.133,5.865-5.598,6.398-6.998c0.533-1.397,0.668-3.732,0.668-3.732s0,0,2.199,1.867c2.199,1.865,2.332,4.6,2.998,7.73 s2.332,0.934,2.332-0.467c0-1.401,0.269-5.465-1-7.064c-1.265-1.6-3.73-3.465-3.73-5.265s1.199-3.732,1.199-3.732 c0.332,1.667,3.335,3.065,5.599,3.399C38.668,33.206,38.533,31.207,36.867,30.74z',
	planeA: 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z',
	body: 'path://M35.5 40.5c0-22.16 17.84-40 40-40s40 17.84 40 40c0 1.6939-.1042 3.3626-.3067 5H35.8067c-.2025-1.6374-.3067-3.3061-.3067-5zm90.9621-2.6663c-.62-1.4856-.9621-3.1182-.9621-4.8337 0-6.925 5.575-12.5 12.5-12.5s12.5 5.575 12.5 12.5a12.685 12.685 0 0 1-.1529 1.9691l.9537.5506-15.6454 27.0986-.1554-.0897V65.5h-28.7285c-7.318 9.1548-18.587 15-31.2715 15s-23.9535-5.8452-31.2715-15H15.5v-2.8059l-.0937.0437-8.8727-19.0274C2.912 41.5258.5 37.5549.5 33c0-6.925 5.575-12.5 12.5-12.5S25.5 26.075 25.5 33c0 .9035-.0949 1.784-.2753 2.6321L29.8262 45.5h92.2098z',
	rewind: 'path://M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z',
	flash: 'path://M12.566,24H8.719l2-8H6.586a2.561,2.561,0,0,1-2.451-3.3L7.976,0h9.467l-3,8h4.023a2.533,2.533,0,0,1,2.11,3.932Z',
	zhuaArrow: 'path://M916.70478 440.270049L531.68078 217.987122c-21.079415-12.188098-47.953171-13.08722-70.631024 0s-35.365463 36.764098-35.365463 61.140293v97.304975H127.37561c-34.766049 0-62.938537 28.172488-62.938537 62.938537v145.258146c0 34.766049 28.172488 62.938537 62.938537 62.938537h298.308683v90.411707c0 26.673951 13.886439 52.748488 38.662244 67.034537 24.775805 14.385951 54.247024 13.386927 77.524292 0l374.833951-216.388683c25.674927-14.685659 42.858146-42.458537 42.858147-74.227512 0-31.469268-17.18322-59.242146-42.858147-74.12761z',
	doubleArrow: "path://M877.5 565.9l-367.6-340-367.6 340c-22.5 14.5-52.5 14.5-67.5 0-15-21.7-15-50.7 0-65.1L495 117.5c0-7.2 7.5-7.2 15-7.2s7.5 0 15 7.2l420.2 383.3c22.5 21.7 15 50.6 0 65.1-22.7 14.5-52.7 14.5-67.7 0zM494.8 450.1c0-7.2 7.5-7.2 15-7.2s15 0 15 7.2L945 833.4c22.5 21.7 15 50.6 0 65.1-22.5 14.4-52.5 14.4-67.5 0L509.8 558.6 142.2 905.8c-22.5 14.5-52.5 14.5-67.5 0-15-21.7-15-50.7 0-65.1l420.1-390.6z"
};

// var heatLineList=[
// 		// {
// 		// 	"datas":[119.371956,29.347082,119.371607,29.347110,119.368744,29.347843,119.364716,29.349106,119.361116,29.347226,119.357842,29.345515,119.353084,29.343018,119.350105,29.341483,119.347503,29.340154,119.345022,29.339882,119.341805,29.342412,119.337068,29.346128,119.335538,29.347365,119.333757,29.348793,119.332083,29.349293,119.326269,29.348651,119.319307,29.347859,119.314068,29.349095,119.309868,29.350068,119.303480,29.352732,119.298747,29.354642,119.294211,29.356473,119.287934,29.359005,119.279581,29.362375,119.277009,29.363413,119.270367,29.366091,119.263492,29.365046,119.260092,29.366037,119.257204,29.367487,119.253744,29.369208,119.253177,29.369648,119.252029,29.370573,119.245673,29.372073,119.241648,29.373036,119.237454,29.375668,119.235878,29.376905,119.232100,29.379768,119.228933,29.380717,119.222579,29.382589,119.219803,29.382722,119.218847,29.382768,119.217197,29.382684,119.215179,29.382624,119.213207,29.382556,119.211598,29.382494,119.210464,29.382445,119.208456,29.382369,119.207340,29.382335,119.205103,29.382245,119.202979,29.382167,119.201533,29.382108,119.200895,29.380729,119.201168,29.380560],
// 		// 	"weight":"10"
// 		// }
// 		];
function createHeatlineLayer() {


	console.log("createHeatlineLayer")
	heatLineAnimatonLayer = new ol3Echarts(null, {
		hideOnMoving: true,
		hideOnZooming: true
	});

	heatLineAnimatonLayer.appendTo(window.global.map);
	heatLineAnimatonLayer.setZIndex(9999)

	if(window.global.applicationScene=='asia' ){
			getHeatLinePowerData();
	}
}

var lasetGetIndex = 0;
var tideWAyModel = 1;
var timeData = [];
var featuresData = [];
var trackData = [];
var tidwayFeatureAll = [];

function isvPointNaN(pt) {
	return isNaN(pt[0]) || isNaN(pt[1]);
}

async function getHeatLinePowerData() {
	asiaChildLinePowerData=[];

	await getAsiaLinePower().then((res) => {
		let msgData = res.data
		asiaChildLinePowerData=msgData
		msgData.forEach((item) => {
			asiaChildLinePowerData.push(item.data)
			suportEastChinaData.forEach((e) => {
				e.fromPoints.forEach((r) => {
					if (r.code == item.code) {
						r.value = Math.abs(item.power.toFixed(1))
					}
				})
			})
			// suportHangzhouData.forEach((e) => {
			// 	e.fromPoints.forEach((r) => {
			// 		if (r.code == item.code) {
			// 			r.value = Math.abs(item.power.toFixed(2))
			// 		}
			// 	})
			// })
			suportZhejiangData.forEach((e) => {
				e.fromPoints.forEach((r) => {
					if (r.code == item.code) {
						r.value = Math.abs(item.power.toFixed(2))
					}
				})
			})
			suportCoreData.forEach((e) => {
				
				e.fromPoints.forEach((r) => {
					if (r.code == item.code) {
						r.value = Math.abs(item.power.toFixed(2))
					}
				})
			})
		})
	})
		let hzMeasure=window.global.measureData.data["0101330100"]["21032001"]
		let jhMeasure=window.global.measureData.data["0101330700"]["21032001"]
		let huzMeasure=window.global.measureData.data["0101330500"]["21032001"]
		let sxMeasure=window.global.measureData.data["0101330600"]["21032001"]
		let wzMeasure=window.global.measureData.data["0101330300"]["21032001"]
		let nbMeasure=window.global.measureData.data["0101330200"]["21032001"]
	
		suportHangzhouData.forEach((e) => {
				e.fromPoints.forEach((r) => {
						for(let key in window.global.measureData.data){
							if(r.code==key)
							r.value = Math.abs( window.global.measureData.data[key]["21032001"].toFixed(2))
						}
				})
			})

	

	refreshHeatLineAuto()
}



// var flyLineColor=['#a6c84c', '#ffa022', '#46bee9','#c44444'];
var flyLineColor = ['#5ee7f4'];


//              
var suportZhejiangData = [
	{
	"fromPoints": [{
			"name": "福建",
			"to":"",
			"line": ["都榕I、II线", "宁剑5906线", "宁川5916线"],
			"lineTooltips": ["fujian_zhejiang"],
			"code": "fujian_zhejiang",
			"position": [118.23282236638521,26.689206194904344],
			"value": "0",
			centerCoor: [118.8362113139583, 25.25213384932063],
			"curveness": 0.61
		},
		{
			"name": "安徽",
			"to":"",
			"line": ["湖安I、II线", "沥富5921线", "等5条线"],
			"lineTooltips": ["anhui_zhejiang"],
			"code": "anhui_zhejiang",
			"position": [116.05616157661512,30.193707556237086],
			"value": "0",
			centerCoor: [113.99331146300881,29.837317879144007],
			"curveness": 0.41
		},
		{
			"name": "江苏",
			"to":"",
			"line": ["瓶武5905线", "窑武5915线"],
			"lineTooltips": ["jiangsu_zhejiang"],
			"code": "jiangsu_zhejiang",
			"position": [119.1127245470605,30.87891508171684],
			"value": "0",
			centerCoor: [121.800109909666848, 30.898158711413356],
			"curveness": 0.41
		}

	],
	"toPoint": {
		"name": "浙江",
		"position": [120.26042304359346,28.704496955528256],
		"value": "0"
	}
},
	{
	"fromPoints": [
		{
			"name": "浙江",
			"to":"上海:",
			"line": ["安塘I、II线", "汾林5912线", "汾三5902线"],
			'lineTooltips': ["shanghai_zhejiang"],
			"code": "shanghai_zhejiang",
			"position": [120.26042304359346,28.704496955528256],
			"value": "0",
			"centerCoor": [124.08874868353908,29.70627493751553],
			"curveness": 0.35
		},
	],
	"toPoint": {
		"name": "上海",
		"position": [ 121.6185329311575,30.004888174764446],
		"value": "0"
	}
}

];
//            
//        

      
var suportHangzhouData = [{
	"fromPoints": [{
			"name": "杭州",
			"to":"",
			"code": "0101330100",
			"line": [],
			"lineTooltips": [""],
			"position": [],
			"value": "0",
			"centerCoor": [119.47510427788633,29.139001128183253],
			"aminationCoor": [],
			"curveness": -0.31
		},
		{
			"name": "宁波",
			"to":"",
			"code": "0101330200",
			"line": [],
			"lineTooltips": [""],
			"position": [ ],
			"value": "0",
			"centerCoor": [122.1785447547861,29.091492829665228],
			"aminationCoor": [122.2785447547861,29.026492829665228],
			"curveness": -0.51
		},
		{
			"name": "湖州",
			"to":"",
			"code": "0101330500",
			"line": [],
			"lineTooltips": [""],
			"position": [],
			"value": "0",
			"centerCoor": [120.35195498963916,29.6331325507180],
			"aminationCoor": [120.35195498963916,29.5831325507180],
			"curveness": -0.51
		},
		{
			"name": "绍兴",
			"to":"",
			"code": "0101330600",
			"line": [],
			"lineTooltips": [""],
			"position": [],
			"value": "0",
			"centerCoor": [121.26863882950743,29.057544903991214],
			"aminationCoor": [121.32863882950743,28.957544903991214],
			"curveness": -0.31
		},
		{
			"name": "金华",
			"to":"",
			"code": "0101330700",
			"line": [],
			"lineTooltips": [""],
			"position": [],
			"value": "0",
			"centerCoor": [120.27426991846386,28.66293410209748],
			"aminationCoor": [120.35426991846386,28.61293410209748],
			"curveness": -0.41
		},
		{
			"name": "温州",
			"to":"",
			"code": "0101330300",
			"line": [],
			"lineTooltips": [""],
			"position": [],
			"value": "0",
			"centerCoor": [120.79674108039398,27.889852567945525],
			"aminationCoor": [120.83674108039398,27.729852567945525],
			"curveness": -0.41
		}
	
	],
	"toPoint": {
		"name": "杭州",
		"position": [119.28617830635644,28.953377470365794 ],
		"aminationCoor": [119.57510427788633,29.059001128183253],
		"value": "0"
	},

}];

var suportCoreData = [{
	"fromPoints": [{
		"name": "滨江区",
		"code": "binjiang_zhongxin",
		line: ["兴彩2R67线", "闻虹2R76线", "等19条线"],
		"position": [120.208924018563, 30.118316432337352],
		"value": "0",
		centerCoor: [120.21062038502397, 30.20443337320353],
	}, ],
	"toPoint": {
		"name": "奥体",
		"position": [120.22453708465575, 30.231722134832026],
		"value": "0"
	}
}];

//                   
var suportEastChinaData = [{
		"fromPoints": [
			{
				"name": "西北",
				"to":"安徽",
				"code": "northwest_zhejiang",
				"position": [103.00933113252784,32.3041526],
				"value": "0",
				"centerCoor": [103.47903602728654, 32.575670048146932],
				"line": ["灵绍直流"],
				"lineTooltips":["northwest_zhejiang"],
				"curveness": 0.34
			},
			{
				"name": "西北",
				"to":"安徽:",
				"code": "northwest_anhui",
				"position": [100.30933113252784,31.0041526],
				"value": "0",
				"centerCoor": [100.01918162161283, 30.575670048146932],
				"line": ["吉泉直流"],
				"lineTooltips":["northwest_anhui"],
				"curveness": 0.33
			},
	
			{
				"name": "西南",
				"to":"江苏",
				"code": "southwest_zhejiang_bj",
				"position": [108.0075,28.8507],
				"value": "0",
				"centerCoor": [109.8075,27.5507],	
				"lineTooltips":["southwest_zhejiang_bj"],
				"line": ["宾金直流"],
				"curveness": 0.39
			},
			{
				"name": "西南",
				"to":"江苏",
				"code": "southwest_jingsu",
				"position": [105.7075,28.6507],
				"value": "0",
				"centerCoor": [105.2075,27.5507],	
				"lineTooltips":["southwest_jingsu"],
				"line": [ "建苏直流"],
				"curveness": 0.41
			},
			{
				"name": "西南",
				"code": "southwest_jiangsu",
				"to":"江苏:",
				"position": [106.9075,28.4507],
				"value": "0",
				"centerCoor": [107.4075,26.8507],
				'line': ["锦苏直流"],
				'lineTooltips':["southwest_jiangsu"],
				"curveness": 0.44
			},
			{
				"name": "西南",
				"code": "southwest_zhejiang_jt",
				"to":"江苏:",
				"position": [105.0075,29.3507],
				"value": "0",
				"centerCoor": [104.7075,28.4507],
				'line': [ "金塘直流"],
				'lineTooltips':["southwest_zhejiang_jt"],
				"curveness": 0.38
			},
			{
				"name": "西南",
				"code": "southwest_shanghai",
				"to":"上海:",
				"position": [109.0075,28.5507],
				"value": "0",
				"centerCoor": [111.0075,26.5507],
				"line": ["复奉直流"],
				"lineTooltips":["southwest_shanghai"],
				"curveness": 0.37
			},
			{
				"name": "华中",
				"code": "centralchina_jiangsu",
				"to":"江苏:",
				"line": ["龙政直流"],
				'lineTooltips':["centralchina_jiangsu"],
				"position": [112.6761365107589,29.069185505689063],
				"value": "0",
				'centerCoor': [116.59776153630395, 27.320402962127422],
				"curveness": 0.32
			},
			{
				"name": "华中",
				"code": "centralchina_shanghai",
				"to":"上海:",
				"line": ["葛南直流", "林枫直流","宜华"],
				"lineTooltips":["centralchina_shanghai"],
				"position": [],
				"value": "0",
				"centerCoor": [113.39776153630395, 27.320402962127422],
			},
			{
				"name": "华北",
				"to":"江苏:",
				"code": "northchina_jiangsu_xt",
				"position": [113.03709934873493,32.48908033946224 ],
				"value": "0",
				"centerCoor": [114.33189974278835,33.004305916183856],
				"line": ["锡泰直流"],
				"lineTooltips": ["northchina_jiangsu_xt"],
				"curveness": 0.44
			},
			{
				"name": "华北",
				"to":"江苏:",
				"code": "northchina_jiangsu_yh",
				"position": [115.63709934873493,32.28908033946224 ],
				"value": "0",
				"centerCoor": [119.63189974278835,31.804305916183856],
				"line": ["雁淮直流"],
				"lineTooltips": ["northchina_jiangsu_yh"],
				"curveness": 0.44
			}
		],
		"toPoint": {
			"name": "华东",
			"position": [118.00453669566965,28.733798576762257],
			"value": "0"
		}
	},
	// {    
	// 	"fromPoints":[
	// 		{"name":"西北","code":"northwest_anhui",
	// 		line:["吉泉Ⅰ线","吉泉Ⅱ线"],"position":[102.94233090986002,32.86377886932907],"value":"0",
	// 		centerCoor:[113.16547069780451,37.005008836924276],startcoor:[107.07359293073483,36.78804623224637],endcoor:[113.16547069780451,37.005008836924276]},

	// 	],
	// 	"toPoint":{
	// 		"name":"安徽",
	// 		"position":[117.01886580682071,29.24442730622414],
	// 		"value":"0"
	// 	}
	// },
	// {  
	// 	"fromPoints":[	
	// 		{"name":"华中","code":"centralchina_jiangsu",line:["龙政直流","宜华直流","林枫直流"],"position":[113.38320447581765,29.163054670525824],"value":"0",
	// 		centerCoor:[113.66287073204863,25.744590937263297],startcoor:[113.50750058969807,29.89307147918359],endcoor:[113.66287073204863,25.744590937263297]},
	// 		// {"name":"西南","code":"southwest_jiangsu", "position":[104.93106873194719,29.812219187875726],"value":"0",
	// 		// centerCoor:[99.30666957885693,30.5375215968007],line:["锦苏直流","建苏直流"],startcoor:[106.98195461097458,29.434045161503477],endcoor:[99.30666957885693,30.5375215968007]
	// 		// },
	// 		//  
	// 		{"name":"华北","code":"northchina_jiangsu", "position":[114.78153575697266,32.62855882323434],"value":"0",
	// 		centerCoor:[119.28726988513891,34.595155050723704],line:["锡泰直流","雁淮直流"],startcoor:[117.88893860398387,32.9681215301658 ],endcoor:[119.28726988513891,34.595155050723704]
	// 		}
	// 	],
	// 	"toPoint":{
	// 		"name":"江苏",
	// 		"position":[117.01886580682071,29.24442730622414],
	// 		"value":"0"
	// 	}
	// },
	// {
	// 	"fromPoints":[
	// 		{"name":"华中","code":"centralchina_shanghai",line:["宜华直流","林枫直流"],"position":[113.89592594557448,27.549756862773236],"value":"0",
	// 		centerCoor:[119.10082571431825,28.618926546458724],startcoor:[117.85786457551376,30.964798268119935],endcoor:[119.10082571431825,28.618926546458724]},
	// 		{"name":"西南","code":"southwest_shanghai",line:["复奉直流","葛南直流"], "position":[104.93106873194719,29.812219187875726],"value":"0",
	// 		centerCoor:[107.44806503802624,31.6550566972103 ],startcoor:[110.2136535718662,30.242672737355207],endcoor:[107.44806503802624,31.6550566972103 ]}
	// 	],
	// 	"toPoint":{
	// 		"name":"上海",
	// 		"position":[117.01886580682071,29.24442730622414],
	// 		"value":"0"
	// 	}
	// },


]


function clearAmitationOverlay(){
	if(window.global.lighterOverlays==[]){
		return
	}
	window.global.lighterOverlays.forEach((item)=>{
		window.global.map.removeOverlay(item)
	})
	window.global.lighterOverlays=[]
}
function createCssAminationLayer(lon, lat,type,val) {
    var parentDiv = document.createElement('div');
    parentDiv.className = "parentdiv";
	let scalValue=0.5
	if(val){
		scalValue=val
	}
    for( var i=0 ;i<=4;i++){
		let  className=[]
		if(type){
			className=["beam","high_light_fornt","high_light_back","fixed_glow",'shot_glow']
		}else{
			className=["beam","high_light_fornt","high_light_back","fixed_glow",'anishot_glow']
		}
		var childDiv= document.createElement('div');
		childDiv.className=className[i]
		childDiv.style.transform=`scale(${scalValue})`
		parentDiv.appendChild(childDiv)
    }
    let lighterOverlay = new Overlay({
        element: parentDiv,
        positioning: 'center-center',
        offset: [-15, -13],
    });
 	// let overlaySize=lighterOverlay.getSize()
	//  lighterOverlay.setSize([overlaySize[0]*0.5,overlaySize[1]*0.5])
    window.global.map.addOverlay(lighterOverlay);
    window.global.lighterOverlays.push(lighterOverlay);
    //设置点击事件位置
    let Location = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
    //设置点击事件的样式
    setTimeout(()=>{
		lighterOverlay.setPosition(Location);
	},2000)
}
function addPointerAni(val){
	let dataArr=[]
	if (val == 0)
	dataArr=suportEastChinaData
	else if (val == 1)
		dataArr=suportZhejiangData
	else if (val== 2)
		dataArr=suportHangzhouData
	else
		return
		
		let drawOverArr=[];
		let toPointCoors 
		if(val==2){
			dataArr.forEach(function (item, i) {
				let fromPoints = item.fromPoints
				 toPointCoors = item.toPoint.aminationCoor;
				// drawOverArr.push(toPoint.position)
				fromPoints.forEach(function (dataItem, i) {
				if(dataItem.aminationCoor.length==2){
					drawOverArr.push(dataItem.aminationCoor);
				}
				});
			});
			createCssAminationLayer(toPointCoors[0],toPointCoors[1],true,0.75)
			drawOverArr.forEach((t)=>{
				createCssAminationLayer(t[0],t[1],true)
			})
		}else{
			dataArr.forEach(function (item, i) {
				let fromPoints = item.fromPoints
				 toPointCoors = item.toPoint.position;
				// drawOverArr.push(toPoint.position)
				fromPoints.forEach(function (dataItem, i) {
				if(dataItem.position.length==2){
					drawOverArr.push(dataItem.position);
				}
				});
			});
			createCssAminationLayer(toPointCoors[0],toPointCoors[1],false)
			drawOverArr.forEach((t)=>{
				createCssAminationLayer(t[0],t[1],true)
			})
		}


}


function flyTrack(pointsList,status) {
	if(asiaChildLinePowerData.length==0){
		return
	}
	let echartsOption = {
		// title: {
		//     text: "全网保华东",
		//     subtext: "<span>1111</span>",
		//     left: 'center',
		//     textStyle: {
		//         color: '#fff'
		//     }
		// },
		tooltip: {
			trigger: 'item'
		},
		series: []
	};
	if (heatLineAnimatonLayer != null) {
		heatLineAnimatonLayer.hide();
		heatLineAnimatonLayer.setChartOptions(echartsOption, true);
	}


	heatLineAnimatonLayer.clear(false);
	setTimeout(() => {
		let series = []
		let centerCoors = []
		let markLine = []
		let flyData = []

		pointsList.forEach(function (item, i) {
			let fromPoints = item.fromPoints
			let toPoint = item.toPoint;
			
			fromPoints.forEach(function (dataItem, i) {

				let curveness = window.common.safeGetJsonKey(dataItem, "curveness", 0.31);
				flyData.push({
					fromName: dataItem.name,
					toName: toPoint.name,
					coords: [dataItem.position, toPoint.position],
					name: dataItem.name + '-' + toPoint.name,
					value: dataItem.value,
					lineTooltips:dataItem.lineTooltips,
					lineStyle: {
						normal: {
							curveness: curveness
						}
					}
				});
				centerCoors.push({
					name: dataItem.name + '-' + toPoint.name,
					to:dataItem.to,
					value: dataItem.value,
					coord: dataItem.centerCoor,
					line: dataItem.line,
					lineTooltips:dataItem.lineTooltips,
				})
			});

			series.push({
					name: "",
					type: 'lines',
					coordinateSystem: 'openlayers',
					zlevel: 8,
					effect: {
						show: true,
						period: 10,
						trailLength: 0.2,
						color: '#fff',
						opacity: 0.7,
						symbolSize: 4
					},
					lineStyle: {
						normal: {
							color: "#fff",
							width: 0,
						}
					},
					data: flyData
				}, {
					name: "",
					type: 'lines',
					coordinateSystem: 'geo',
					zlevel: 2,
					symbol: ['none', 'none'],
					symbolSize: 6,			
					tooltip: {
						trigger: 'item',
						backgroundColor: 'transparent',
						formatter: (param) => {
							let lineTooltips = param.data.lineTooltips
							let allLine=[];
							let text=""
							lineTooltips.forEach((lineItem)=>{
							let lineArray= asiaChildLinePowerData.filter(item => {
									return item.code == lineItem
								});
								lineArray.forEach((lineData)=>{
									lineData.data.forEach((data)=>{
										allLine.push(data)
									})
								})
							})
							allLine.forEach((item)=>{
								text+=`<span style='color:#fff'>${item.name}:</span><span style='color:#e6da57' >${Math.abs(item.power.toFixed(2))}</span> <span style='color:#fff'>MW</span>`
								text+='<br/>'

							})
							return text
						},
						position:[850,140],
						// position:"bottom",
						textStyle:{
							align:'left'
						}

					},
					tooltips:{
						show:false
					},
					markPoint: {
						symbol: 'circle',
						symbolSize: 0,
						label: {
							normal: {
								show: true,
								position: 'inside',
								// formatter: '{title|{b}} {abg|} \n{bValue|{c}}MW\n{hr|}\n',
								formatter: (param) => {
									// console.log(param)
									let to=param.data.to
									let t = param.name
									let b = param.data.line
									let power = param.data.value
									// return 	`{title|${t}}{abg|}\n{bValue|${b[0]||""}、}{bValue|${b[1]||""}}\n{bValue|${b[2]||""}}{aValue|${power}}{cValue|MW}`
									return `{bValue|${b[0]||""}}{bValue|${b[1]||""}}\n{bValue|${b[2]||""}}{aValue|${power}}{cValue|MW}`
								},
								// backgroundColor: {
								// 	// image:'/img/jpg/label.png'
								// 	color:"transparent"
								// }, //标签背景颜色
								itemStyle: {
									opacity: 1
								},
								borderColor: 'transparent', //外层边框颜色
								height: 58,
								width: 170,
								fontSize: 12,
								color: '#fff',
								borderWidth: 0.5, //外层边框宽度
								borderRadius: 5, //外层边框圆角
								// shadowBlur:0.5,
								// shadowColor:"#2097fb",
								// shadowOffsetX:0.6,
								// shadowOffsetY:0.6,
								rich: {
									title: {
										color: '#fff',
										align: 'center',
										fontSize: 14,
										fontWeight: "bold"
									},
									abg: {
										backgroundColor: 'transparent',
										width: '100%',
										align: 'right',
										height: 25,
										borderRadius: [4, 4, 0, 0]
									},
									bValue: {
										color: '#fff',
										padding: [0, 2, 0, 2],
										align: 'left',
										fontSize: 12,
									},
									aValue: {
										color: '#e6da57',
										padding: [0, 2, 0, 0],
										align: 'left',
										fontSize: 15,
										height: 20
									},
									cValue: {
										color: '#f7f7f7',
										padding: [0, 6, 0, 0],
										align: 'left',
										fontSize: 12,
										height: 20
									},
									hr: {
										borderColor: '#777',
										width: '100%',
										borderWidth: 0,
										height: 0
									}
								}
							}
						},
						tooltip: {
							trigger: 'item',
							backgroundColor: 'transparent',
							formatter: (param) => {
								let lineTooltips = param.data.lineTooltips
								let allLine=[];
								let text=""
								lineTooltips.forEach((lineItem)=>{
								let lineArray= asiaChildLinePowerData.filter(item => {
										return item.code == lineItem
									});
									lineArray.forEach((lineData)=>{
										lineData.data.forEach((data)=>{
											allLine.push(data)
										})
									})
								})
								allLine.forEach((item)=>{
									text+=`<span style='color:#fff'>${item.name}:</span><span style='color:#e6da57' >${Math.abs(item.power.toFixed(2))}</span> <span style='color:#fff'>MW</span>`
									text+='<br/>'
		
								})
								return text
							},
							position:[850,140],
							// position:"bottom",
							textStyle:{
								align:'left'
							}

						},
						data: centerCoors
					},
					// markLine:{
					// 	data:markLine
					// },
					// effect: {
					//     show: true,
					//     period: 10,
					//     trailLength: 0.8,
					//     symbol: pathSymbols.doubleArrow,
					//     symbolSize: 10
					// },
					lineStyle: {
						normal: {
							color: flyLineColor[i % flyLineColor.length],
							width: 1.5,
							opacity: 1,
							shadowColor: flyLineColor[i % flyLineColor.length],
							shadowBlur: 6
							// shadowBlur:0.5,
							// shadowColor:"#2097fb",
							// shadowOffsetX:0.6,
							// shadowOffsetY:0.6,
						}
					},
					data: flyData
				},
				// {
				//     name: "",
				//     type: 'effectScatter',
				//     coordinateSystem: 'openlayers',
				//     zlevel: 2,
				//     rippleEffect: {
				//         brushType: 'stroke'
				//     },
				//     label: {
				//         normal: {
				//             show: true,
				//             position: 'bottom',
				//             formatter: '{b}'
				//         }
				//     },
				// 	tooltip:{
				// 		show:false,
				// 	},
				//     symbolSize: function (val) {
				//         return 20;
				//     },
				//     itemStyle: {
				//         normal: {
				//             color: flyLineColor[i]
				//         }
				//     },
				// 	data: fromPoints.concat(toPoint).map(function (dataItem) {
				//         return {
				//             name: dataItem.name,
				//             value: dataItem.position.concat(dataItem.value)
				//         };
				//     })
				// }
			);
		});



		let echartsOption = {
			// title: {
			//     text: "全网保华东",
			//     subtext: "<span>1111</span>",
			//     left: 'center',
			//     textStyle: {
			//         color: '#fff'
			//     }
			// },
			tooltip: {
				trigger: 'item'
			},
			series: series
		};
		if (heatLineAnimatonLayer != null) {
			heatLineAnimatonLayer.show();
			heatLineAnimatonLayer.setChartOptions(echartsOption, true);
		}
	}, 2000)
}

function trendGeted(pointsList, powerList) {
	// pointsList=[[[120,29],[120.1,29,1],[121.2,29,2]],
	// 			[[120.2,29.2],[120.1,29,1],[121.0,29,1]],
	// 		]
	let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
	let m = window.global.map.getView().calculateExtent(window.global.map.getSize());
	let t = transform([m[0], m[1]], 'EPSG:3857', 'EPSG:4326');
	m[0] = t[0];
	m[1] = t[1];
	t = transform([m[2], m[3]], 'EPSG:3857', 'EPSG:4326');
	m[2] = t[0];
	m[3] = t[1];

	let step = 1;
	if (heatLineAnimatonLayer == null)
		return;

	heatLineAnimatonLayer.hideLoading();
	trackData = [];
	for (let j = 0; j < pointsList.length; j++) {
		let points = pointsList[j]
		let rawcoors = window.common.cutTracepoints(points);
		let cutPoints = [];
		let ci = 0;
		for (let i = 0; i < rawcoors.length; i++) {
			if (rawcoors[i][0] < m[0] || rawcoors[i][0] >= m[2])
				continue;
			if (rawcoors[i][1] < m[1] || rawcoors[i][1] >= m[3])
				continue;
			cutPoints[ci] = rawcoors[i];
			ci++;
		}
		if (cutPoints.length <= 1)
			continue;

		let t = {
			coords: cutPoints,
			lineStyle: {
				normal: {
					//color: echarts.color.modifyHSL('#5A94DF', Math.round(hStep * l))
					//color: echarts.color.modifyHSL('#1A9F54', Math.round(hStep *j))
					color: '#5A94DF' //line colore
				}
			}
		};
		trackData.push(t);
	}

	if (trackData.length == 0) {
		return;
	}

	let s = 6 + (curZoom - 6) * 1;
	if (s < 1.0)
		s = 1.0;
	else if (s >= 6.0)
		s = 6.0;
	let speed = 10 + (curZoom - 6) * 2;
	if (speed <= 2)
		speed = 2;
	speed = 10 + speed;

	let symbolSvg = pathSymbols.planeA;
	let sSize = 12;
	let effectSymbol = 'circle'
	if (window.global.tideWayModeStatus == 'asiaway') {
		symbolSvg = pathSymbols.doubleArrow;
		sSize = 8;
		effectSymbol = "arrow";
	}

	let echartsOption = {
		series: [

			{
				type: 'lines',
				polyline: true,
				data: trackData,
				lineStyle: {
					normal: {
						width: 0,
						color: "#ffffff",
					}
				},
				effect: {

					show: true,
					// period: 10,
					constantSpeed: speed,
					trailLength: 0.0,
					color: "#a400b9",
					symbol: symbolSvg, //效果
					symbolSize: sSize,
				},
				zlevel: 2
			}, {
				type: 'lines',
				polyline: true,
				data: trackData,
				lineStyle: {
					normal: {
						width: 0,
						color: "#ffffff",
					}
				},
				effect: {
					show: true,
					// period: 10,
					constantSpeed: speed,
					trailLength: 0.5,
					symbol: effectSymbol,
					symbolSize: 6,
					color: "#ffffff",
				},
				zlevel: 1
			}

			// , {
			// 	name: 'Pressure',
			// 	type: 'gauge',
			// 	max:1000,
			// 	progress: {
			// 	  show: true
			// 	},
			// 	detail: {
			// 	  valueAnimation: true,
			// 	  formatter: '{value}'
			// 	},
			// 	data: [
			// 	  {
			// 		value: trackData.length,
			// 		name: 'SCORE'
			// 	  }
			// 	]
			//   }
		]
	};
	if (heatLineAnimatonLayer != null) {
		heatLineAnimatonLayer.show();
		heatLineAnimatonLayer.setChartOptions(echartsOption);

	}
}






function featureGeted(index, result, featuers) {
	let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
	let m = window.global.map.getView().calculateExtent(window.global.map.getSize());

	let step = 1;
	if (heatLineAnimatonLayer == null)
		return;



	if (result == "success") {
		if (window.global.tideWayModeStatus == "allway") {
			for (let j = 0; j < featuers.length; j++) {
				let feature = featuers[j]
				featuresData.push(feature)
			}
		} else {
			featuresData = featuers;

		}
	}

	if (window.global.tideWayModeStatus == "allway" && index != lasetGetIndex)
		return;
	// if (timeData.length == 0) {
	// 	heatLineAnimatonLayer.hideLoading();
	// 	return;
	// }
	let lineIdList = [];
	let lineList = [];

	for (let j = 0; j < featuresData.length; j++) {
		let feature = featuresData[j]
		let fetProp = window.common.getFeatureProperties(feature);
		let tid = window.common.safeGetJsonKey(fetProp, "id", "");
		let end_st_id = window.common.safeGetJsonKey(fetProp, "end_st_id", "");
		let start_st_id = window.common.safeGetJsonKey(fetProp, "start_st_id", "");
		let idItem = {
			"id": tid,
			"start_st_id": start_st_id,
			"end_st_id": end_st_id,

		}
		lineIdList.push(idItem)
		lineList.push(feature)

	}
	postTideWayList(lineIdList, lineList, tabelIndex)



}

function closeHeatLine() {
	if (heatLineAnimatonLayer != null) {
		heatLineAnimatonLayer.clear(false);
		heatLineAnimatonLayer.hide();
		window.setTideWayItem(100, 0, false)
		timeData = [];
		featuresData = [];
		tideWaySingleFeatures = [];
	}
	if (tideWayTimeOut != []) {
		for (let j = 0; j < tideWayTimeOut.length; j++) {
			if (tideWayTimeOut[j] != undefined) {
				clearTimeout(tideWayTimeOut[j]);
			}
		}
	}

	heatLineLayerList = [];
	tideWaySingleFeatures = [];

}

function getTideWayLineIdList(layerList, voltageLevelFilter) {
	let features = null;
	let lineIdList = [];
	let lineList = [];
	let extent = window.global.map.getView().calculateExtent(window.global.map.getSize());
	for (let i = 0; i < layerList.length; i++) {
		let jl = layerList[i];
		// features = jl.ol.getSource().getFeatures()
		features = jl.ol.getSource().getFeaturesInExtent(extent)
		// console.log(features);
		for (let j = 0; j < features.length; j++) {
			let feature = features[j]
			let voltage_type = window.common.safeGetJsonKey(feature.values_, "voltage_type", "")
			// console.log(voltage_type)
			// 过滤一遍
			if (window.global.tideWayVoltageLevel.indexOf(voltage_type) != -1) {
				let fetProp = window.common.getFeatureProperties(feature);
				let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
				let tid = window.common.safeGetJsonKey(fetProp, idField, "");
				let end_st_id = window.common.safeGetJsonKey(fetProp, "end_st_id", "");
				let start_st_id = window.common.safeGetJsonKey(fetProp, "start_st_id", "");
				let idItem = {
					"id": tid,
					"start_st_id": start_st_id,
					"end_st_id": end_st_id,

				}
				lineIdList.push(idItem)
				lineList.push(feature)
			}
		}

	}
	// console.log(lineList)
	// console.log(lineIdList)

	postTideWayList(lineIdList, lineList)
	// 发送给后台，返回数据
}

function postTideWayList(lineIdList, lineList, Index) {

	if (Index == 0) {
		tidwayFeatureAll = []
	}

	let url = "/gis/public/api/lineTide";
	// var params = lineIdList
	var params = {
		"tabelIndex": Index,
		"list": lineIdList
	}
	let listData = [];
	postTideWay(params).then((resp) => {
		// console.log(resp)
		if (resp.code == 200) {
			tabelIndex = resp.data.tabelIndex;
			let data = resp.data.list;
			let featureList = [];
			let arr2Map = {}
			data.forEach((item) => {
				arr2Map[item.id] = item;
				tidwayFeatureAll.push(item)
			})
			console.log(tidwayFeatureAll)
			window.global.tidwayFeatureAll = tidwayFeatureAll
			lineList.forEach((item) => {
				if (arr2Map[item.values_.id]) {

					let t = item.getGeometry().getCoordinates()
					let geoms = transform(t[0], 'EPSG:3857', 'EPSG:4326');
					let geome = transform(t[t.length - 1], 'EPSG:3857', 'EPSG:4326');
					item.direction = arr2Map[item.values_.id].direction;
					featureList.push(item);
				}
			})

			for (let j = 0; j < featureList.length; j++) {

				var points = [];
				let geom = featureList[j].getGeometry();
				let fetProp = window.common.getFeatureProperties(featureList[j]);
				let gtype = geom.getType();
				let direction = featureList[j].direction;
				if (gtype != "LineString" && gtype != "MultiLineString")
					continue;



				let pp;
				if (gtype == "MultiLineString") {
					let datas = window.common.sortLineCoordinates(geom.getLineStrings())[1];
					for (let c = 0, p = 0; c < datas.length; c++) {
						if (datas[c][0] < 0 || datas[c][1] < 0);
						continue;

						let t = transform(datas[c], 'EPSG:3857', 'EPSG:4326');
						points[p] = t;
						p++;
					}
				} else {
					let datas = geom.getCoordinates();
					for (let c = 0, p = 0; c < datas.length; c++) {
						if (datas[c][0] < 0 || datas[c][1] < 0)
							continue;
						let t = transform(datas[c], 'EPSG:3857', 'EPSG:4326');
						points[p] = t;
						p++;
					}
				}
				if (direction == 1) {
					points.reverse();
				}

				timeData.push(points);
			}
			if (timeData.length == 0) {
				heatLineAnimatonLayer.hideLoading();
				return;
			}
			let featureCount = lineIdList.length;
			tideWayCount = tideWayCount + featureList.length;
			window.setTideWayItem(featureCount, tideWayCount, true);
			trendGeted(timeData, []);
			if (tabelIndex != 0) {
				postTideWayList(lineIdList, lineList, tabelIndex);
			} else {
				tideWayCount = featureCount;
				window.setTideWayItem(featureCount, tideWayCount, true);
				tideWayCount = 0;
			}

			// for (let key in lineList) {
			//     // for (let x = 0; x < data.length; x++){

			//     // }
			//     var points = [];
			//     let id = window.common.safeGetJsonKey(lineList[key].values_, "id", "")


			//     let coors = lineList[key]
			//         .getGeometry().getCoordinates()

			//     let startPos = []
			//     let n = coors.length - 1;
			//     let random = Math.random()
			//     if (random < 0.5) {
			//         startPos = coors[0]
			//     } else {
			//         startPos = coors[n]
			//     }

			//     startPos = transform(startPos, 'EPSG:3857', 'EPSG:4326');
			//     console.log(startPos)
			//     let fhead = [120, 30]

			//     for (let i = 0, p = 0; i < coors.length; i++) {
			//         // pointList.push(transform(coors[i], 'EPSG:3857', 'EPSG:4326'));
			//         if (coors[i][0] < 0 || coors[i][1] < 0)
			//             continue;
			//         let t = transform(coors[i], 'EPSG:3857', 'EPSG:4326');
			//         points[p] = t;
			//         p++;

			//     }
			//     pointList.push(points);
			//     console.log(pointList)

			// }
			// window.mapHeatLine.trendGeted(pointList, []);

		}
	});

}


async function openHeatLine(layerList, tideWayModeStatus, fe, fejl) {
	if (heatLineAnimatonLayer == null)
		return;
	window.global.tideWayModeStatus = tideWayModeStatus;

	if (tideWayModeStatus == "asiaway") {
		if (asiaHeatlineData == null) {
			let msg = await syncGetLocalJson("data/asiaHeatline.json");
			asiaHeatlineData = msg.data
		}

		let pointsList = [];
		asiaHeatlineData.forEach((element) => {
			let lfeatuers = [];
			let jl = null
			for (let i = 0; i < layerList.length; i++) {
				jl = layerList[i];
				let ly = jl.ol;
				if (ly == null || !ly.getVisible()) {
					jl = null
					continue;
				}
				if (element.layer == jl.name) {
					let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
					let fs = jl.ol.getSource().getFeatures();
					let ids = element.ids

					fs.forEach((feat) => {
						let fetP = window.common.getFeatureProperties(feat);
						let tid = window.common.safeGetJsonKey(fetP, idField, "");
						if (ids.includes(tid)) {
							lfeatuers.push(feat.getGeometry().getCoordinates());
						}
					});
					break
				}
				jl = null
			}
			if (lfeatuers.length > 0) {
				pointsList.concat(lfeatuers);
			}

		});

		if (pointsList.length > 0) {
			console.log(pointsList);
		}

	} else if (tideWayModeStatus == "allway") {
		timeData = [];
		featuresData = [];
		tideWaySingleFeatures = [];
		// let featureCount=0
		for (let i = 0; i < layerList.length; i++) {
			lasetGetIndex = layerList[i].index;
		}
		let extent = window.global.map.getView().calculateExtent(window.global.map.getSize());

		for (let i = 0; i < layerList.length; i++) {
			let jl = layerList[i];
			let ly = jl.ol;
			let featuersAll = ly.getSource().getFeaturesInExtent(extent);
			let featuers = [];

			if (!ly.getVisible()) {
				continue;
			}
			for (let j = 0; j < featuersAll.length; j++) {
				let feature = featuersAll[j]
				let voltage_type = window.common.safeGetJsonKey(feature.values_, "voltage_type", "")
				if (window.global.tideWayVoltageLevel.indexOf(voltage_type) != -1) {
					let fetProp = window.common.getFeatureProperties(feature);
					featuers.push(feature)
				}
			}
			featureGeted(jl.index, "success", featuers);
		}
	} else {
		let features = [];
		let featuresId = [];
		if (tideWaySingleFeatures.length == 0) {
			tideWaySingleFeatures.push(fe);
			features.push(fe);
		} else {
			tideWaySingleFeatures.forEach((element) => {
				featuresId.push(element.values_.id);
			});

			if (featuresId.indexOf(fe.values_.id) == -1) {
				tideWaySingleFeatures.push(fe);
				features.push(fe);
			} else {
				return;
			}
		}
		console.log(features);
		window.mapHeatLine.featureGeted(fejl.index, "success", features);
	}




	heatLineLayerList = layerList;
}

function hiddenHeatLine() {
	if (heatLineAnimatonLayer == null)
		return;
	heatLineAnimatonLayer.hide();

}

function refreshHeatLineAuto() {

	let extent = window.global.map.getView().calculateExtent(window.global.map.getSize());

	if (heatLineAnimatonLayer == null || heatLineLayerList.length == 0)
		return;
	var curZoom = window.common.getMapZoomInt();



	if (window.global.tideWayModeStatus == "asiaway") {
		if (window.global.curSpportZoom == -1 || window.global.curSpportZoom == 3) {
			hiddenHeatLine();
			return;
		}
		if (window.global.curSpportZoom == 0)
			flyTrack(suportEastChinaData)
		else if (window.global.curSpportZoom == 1)
			flyTrack(suportZhejiangData)
		else if (window.global.curSpportZoom == 2)
			flyTrack(suportHangzhouData)
		else
		flyTrack([])
		
		return
	}

	// heatLineAnimatonLayer.showLoading();
	timeData = [];
	featuresData = [];
	for (let i = 0; i < heatLineLayerList.length; i++) {
		let jl = heatLineLayerList[i];
		let ly = jl.ol;
		let featuersAll = ly.getSource().getFeaturesInExtent(extent);
		let featuers = []
		for (let j = 0; j < featuersAll.length; j++) {
			let feature = featuersAll[j]
			let voltage_type = window.common.safeGetJsonKey(feature.values_, "voltage_type", "")
			// console.log(voltage_type)
			// 过滤一遍
			if (window.global.tideWayVoltageLevel.indexOf(voltage_type) != -1) {
				let fetProp = window.common.getFeatureProperties(feature);
				let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
				let tid = window.common.safeGetJsonKey(fetProp, idField, "");
				featuers.push(feature)
			}
		}
		if (window.global.tideWayModeStatus == "asiaway") {
			let pointsList = []
			for (let ii = 0; ii < asiaHeatlineData.length; ii++) {
				let element = asiaHeatlineData[ii];
				if (element.layer == jl.name) {
					let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
					let ids = element.ids
					for (let j = 0; j < featuers.length; j++) {
						let feat = featuers[j];
						let fetP = window.common.getFeatureProperties(feat);
						let tid = window.common.safeGetJsonKey(fetP, idField, "");
						if (ids.includes(tid)) {
							let coors = feat.getGeometry().getCoordinates();
							for (let jj = 0; jj < coors.length; jj++) {
								coors[jj] = transform(coors[jj], 'EPSG:3857', 'EPSG:4326');
							}
							pointsList.push(coors);
						}
					}
					break;

				}
			}
			if (pointsList.length > 0 && i == heatLineLayerList.length - 1) {
				trendGeted(pointsList, []);
			}
		} else if (window.global.tideWayModeStatus == "allway") {
			featureGeted(jl.index, "success", featuers);
		} else {
			let array = []
			featuers.forEach((item) => {
				tideWaySingleFeatures.forEach((featuresItem) => {
					let featuersId = [];
					featuersId.push(featuresItem.values_.id)
					if (featuersId.indexOf(item.values_.id) != -1) {
						array.push(item)
					}
				})
			})
			featureGeted(jl.index, "success", array);
		}
		//window.mapBase.getFeaturesInExtentbygeoJson(jl.index,jl,featureGeted);
	}


	//pointCollection=null;
}



export default {
	createHeatlineLayer,
	refreshHeatLineAuto,
	openHeatLine,
	closeHeatLine,
	hiddenHeatLine,
	trendGeted,
	featureGeted,
	getHeatLinePowerData,
	createCssAminationLayer,
	addPointerAni,
	clearAmitationOverlay
}